// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   ACTION BUTTON GROUP
========================= */

.action-btn-group {
  display: flex;
  gap: 8px;
  align-items: center;
}

.admin-btn {
  width: 120px;
  padding: 6px 10px;
  border-radius: 4px;
  border: none;
  font-size: 12px;
  cursor: pointer;
  line-height: 1;
}

/* Preview – light green */
.admin-btn.preview {
  background: #dcfce7;
  color: #166534;
}

/* Materialize – blue */
.admin-btn.primary {
  background: #2563eb;
  color: #ffffff;
}

/* View Details – green */
.admin-btn.success {
  background: #16a34a;
  color: #ffffff;
}

/* Disabled */
.admin-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.admin-btn.icon {
  padding: 6px 8px;
  min-width: 37px !important;
  max-width: 37px !important;
}

.admin-btn.danger {
  background: #ffecec;
  color: #c62828;
  border: 1px solid #f5b5b5;
}

.admin-btn.danger:hover {
  background: #fddede;
}


/* =========================
   STATUS BADGES
========================= */

.admin-status {
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  display: inline-block;
}

.admin-status.previewed {
  background: #e0f2fe;
  color: #0369a1;
}

.admin-status.approved {
  background: #fef3c7;
  color: #92400e;
}

.admin-status.completed {
  background: #dcfce7;
  color: #166534;
}

.admin-status.xml_generated {
  background: #ede9fe;
  color: #5b21b6;
}

.admin-status.failed {
  background: #fee2e2;
  color: #991b1b;
}


/* =========================
   DATATABLE SEARCH
========================= */

.datatable-search {
  padding: 6px 10px;
  width: 240px;
  font-size: 13px;
  border-radius: 4px;
  border: 1px solid #d1d5db;
}


/* =========================
   MODAL (FULL SCREEN)
========================= */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;
}

/* 🔴 THIS IS THE IMPORTANT PART */
.modal-container {
  background-color: #ffffff;   /* FORCE solid background */
  opacity: 1;                  /* prevent inheritance */
  
  width: 90vw;
  height: 85vh;

  border-radius: 8px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.35);

  display: flex;
  flex-direction: column;

  position: relative;
  z-index: 10000;
}

.modal-header {
  background: #ffffff;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;

  display: flex;
  justify-content: space-between;
  align-items: center;

  font-weight: 600;
}

.modal-body {
  background: #ffffff;
  flex: 1 1;
  padding: 16px;
  overflow: auto;
  max-height: calc(100vh - 160px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-footer {
  background: #ffffff;
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;

  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
/* Add gap between action buttons */
.rdt_TableCell button + button {
  margin-left: 8px;
}

.rdt_Table {
  table-layout: fixed;
}

.admin-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.admin-btn {
  min-width: 92px;
}

.xml-preview {
  background: #0f172a;
  color: #e5e7eb;
  padding: 16px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.5;

  /* ✅ SCROLL */
  overflow: auto;
  max-height: 100%;

  /* ✅ WRAP LONG LINES */
  white-space: pre-wrap;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/styles/materialize.css"],"names":[],"mappings":"AAAA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;;2BAE2B;;AAE3B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;;2BAE2B;;AAE3B;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;;AAGA;;2BAE2B;;AAE3B;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;;EAEb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,yBAAyB,IAAI,2BAA2B;EACxD,UAAU,mBAAmB,wBAAwB;;EAErD,WAAW;EACX,YAAY;;EAEZ,kBAAkB;EAClB,wCAAwC;;EAExC,aAAa;EACb,sBAAsB;;EAEtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;;EAEhC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,SAAO;EACP,aAAa;EACb,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;;EAE7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA,mCAAmC;AACnC;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;;EAEhB,aAAa;EACb,cAAc;EACd,gBAAgB;;EAEhB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":["/* =========================\n   ACTION BUTTON GROUP\n========================= */\n\n.action-btn-group {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.admin-btn {\n  width: 120px;\n  padding: 6px 10px;\n  border-radius: 4px;\n  border: none;\n  font-size: 12px;\n  cursor: pointer;\n  line-height: 1;\n}\n\n/* Preview – light green */\n.admin-btn.preview {\n  background: #dcfce7;\n  color: #166534;\n}\n\n/* Materialize – blue */\n.admin-btn.primary {\n  background: #2563eb;\n  color: #ffffff;\n}\n\n/* View Details – green */\n.admin-btn.success {\n  background: #16a34a;\n  color: #ffffff;\n}\n\n/* Disabled */\n.admin-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.admin-btn.icon {\n  padding: 6px 8px;\n  min-width: 37px !important;\n  max-width: 37px !important;\n}\n\n.admin-btn.danger {\n  background: #ffecec;\n  color: #c62828;\n  border: 1px solid #f5b5b5;\n}\n\n.admin-btn.danger:hover {\n  background: #fddede;\n}\n\n\n/* =========================\n   STATUS BADGES\n========================= */\n\n.admin-status {\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  display: inline-block;\n}\n\n.admin-status.previewed {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.admin-status.approved {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.admin-status.completed {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.admin-status.xml_generated {\n  background: #ede9fe;\n  color: #5b21b6;\n}\n\n.admin-status.failed {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n\n/* =========================\n   DATATABLE SEARCH\n========================= */\n\n.datatable-search {\n  padding: 6px 10px;\n  width: 240px;\n  font-size: 13px;\n  border-radius: 4px;\n  border: 1px solid #d1d5db;\n}\n\n\n/* =========================\n   MODAL (FULL SCREEN)\n========================= */\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.65);\n  z-index: 9999;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* 🔴 THIS IS THE IMPORTANT PART */\n.modal-container {\n  background-color: #ffffff;   /* FORCE solid background */\n  opacity: 1;                  /* prevent inheritance */\n  \n  width: 90vw;\n  height: 85vh;\n\n  border-radius: 8px;\n  box-shadow: 0 20px 40px rgba(0,0,0,0.35);\n\n  display: flex;\n  flex-direction: column;\n\n  position: relative;\n  z-index: 10000;\n}\n\n.modal-header {\n  background: #ffffff;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e5e7eb;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  font-weight: 600;\n}\n\n.modal-body {\n  background: #ffffff;\n  flex: 1;\n  padding: 16px;\n  overflow: auto;\n  max-height: calc(100vh - 160px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-footer {\n  background: #ffffff;\n  padding: 12px 16px;\n  border-top: 1px solid #e5e7eb;\n\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n/* Add gap between action buttons */\n.rdt_TableCell button + button {\n  margin-left: 8px;\n}\n\n.rdt_Table {\n  table-layout: fixed;\n}\n\n.admin-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.admin-btn {\n  min-width: 92px;\n}\n\n.xml-preview {\n  background: #0f172a;\n  color: #e5e7eb;\n  padding: 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  line-height: 1.5;\n\n  /* ✅ SCROLL */\n  overflow: auto;\n  max-height: 100%;\n\n  /* ✅ WRAP LONG LINES */\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
